import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { FinalTableConfig } from "@beeldit/core/models/FinalTableConfig.interface";
import { Eye, Swap } from "@phosphor-icons/react";
import { Order } from "../models/Order";

const tableConfig: FinalTableConfig = {
  index: null,
  actions: [],
  rowActions: [
    {
      name: RowAction.DETAILS,
      label: "edit",
      icon: <Eye size={20} />,
      allowed: true,
      show: true,
      action: (element: any) => {
        console.log("edit", element);
      },
    },
    {
      name: RowAction.EDIT,
      label: "change_status",
      icon: <Swap size={20} />,
      allowed: true,
      show: (element: any) => element.status < Order.DELIVERED,
      data: 0, // Esto es para que devuelve el objeto entero
      action: (element: any) => {
        console.log("change status", element);
      },
    },
  ],
  rowConfiguration: {
    class: (element: any) => {
      return null;
    },
  },
  columns: [
    {
      name: "id",
      label: "#",
      key: "id",
      type: "number",
      show: true,
      sortable: true,
    },
    {
      name: "reference",
      label: "reference",
      key: "reference",
      type: "string",
      show: true,
      sortable: true,
    },
    {
      name: "status",
      label: "status",
      key: "status",
      type: "translation",
      translation_prefix: "order_status",
      badge: true,
      badge_type: (lower_order_status: any) => {
        if (lower_order_status == Order.PENDING_STATUS) {
          return "warning";
        } else if (lower_order_status == Order.PAYED_STATUS) {
          return "success";
        } else if (
          lower_order_status == Order.IN_PREPARATION ||
          lower_order_status == Order.MANAGING_SHIPMENT ||
          lower_order_status == Order.IN_TRANSIT
        ) {
          return "info";
        } else if (lower_order_status == Order.DELIVERED) {
          return "success";
        } else if (lower_order_status == Order.CANCELLED) {
          return "danger";
        }
      },
      show: true,
      sortable: true,
    },
    {
      name: "created_at",
      label: "created_at",
      key: "created_at",
      type: "datetime",
      show: true,
      sortable: true,
    },
    {
      name: "subtotal_amount",
      label: "subtotal",
      key: "subtotal_amount",
      type: "currency",
      currency: "EUR",
      show: true,
      sortable: true,
    },
  ],
  pagination: {
    enabled: true,
    back: true,
  },
};
const getConfig: any = (functions: any) => {
  const { indexFunction, detailsFunction, prepareChangeStatusFunction } =
    functions;
  tableConfig.index = () => indexFunction();
  tableConfig.rowActions[0].action = (id: any) => detailsFunction(id);
  tableConfig.rowActions[1].action = (element: any) =>
    prepareChangeStatusFunction(element.id, element.status + 1);
  return tableConfig;
};
export default getConfig;
